// material-date-picker-cell-editor.component.ts
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-material-date-picker-cell-editor',
  template: `

    <input #input type="date" class="native-date-input" [(ngModel)]="value" />
  `,
  styles: [`
    .native-date-input {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 4px 8px;
      font-size: 14px;
    }
  `]
})
export class MaterialDatePickerCellEditor implements ICellEditorAngularComp {
 @ViewChild('input', { read: ElementRef }) input!: ElementRef;

  value: string | null = null;

  agInit(params: any): void {
    // Convert input date string to yyyy-MM-dd format for input[type=date]
    if (params.value) {
      const date = new Date(params.value);
      if (!isNaN(date.getTime())) {
        this.value = this.toDateInputValue(date);
      }
    }
  }

  getValue(): any {
    // Return ISO string or null if empty
    // if (!this.value) return null;
    // const date = new Date(this.value);
    // return isNaN(date.getTime()) ? null : date.toISOString();
     if (!this.value) return null;

  // Just return the date string in yyyy-MM-dd format (no time)
  return this.value; 
  }

  afterGuiAttached?(): void {
    // Focus the input field when editor opens
    setTimeout(() => this.input.nativeElement.focus(), 0);
  }

  ngAfterViewInit() {
    // Focus when component loads
    if (this.input) {
      this.input.nativeElement.focus();
    }
  }

  // Helper to format date to yyyy-MM-dd for input[type=date]
  private toDateInputValue(date: Date): string {
    const local = new Date(date);
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return local.toISOString().slice(0, 10);
  }
}